import React from 'react';

export type ArrowProps = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

const triggerSelector =
  'a:hover &, a:focus-visible &, a:focus-within &, button:hover &, button:focus-visible &, button:focus-within &';

function Arrow(props: ArrowProps) {
  return (
    <svg
      width="17"
      height="12"
      aria-hidden
      focusable={false}
      data-arrow-animation=""
      css={{
        transform: 'translateX(0)',
        transition: 'transform 300ms ease',
        [triggerSelector]: {
          transform: 'translateX(4px)',
        },
        '@media (prefers-reduced-motion: reduce)': {
          transitionDuration: '0ms',
        },
      }}
      {...props}
    >
      <g stroke="currentColor" strokeWidth="2" fill="none">
        <path d="M10 1l5 5-5 5" />
        <path
          d="M0 6h14"
          data-arrow-animation-line=""
          css={{
            strokeDasharray: 14,
            strokeDashoffset: -14,
            transition: 'stroke-dashoffset 300ms ease',
            [triggerSelector]: {
              strokeDashoffset: 0,
            },
            '@media (prefers-reduced-motion: reduce)': {
              transitionDuration: '0ms',
            },
          }}
        />
      </g>
    </svg>
  );
}

export default Arrow;
